import { createAction, props } from '@ngrx/store';
import { Expertise, GridLookups, Offer } from 'src/app/shared/models/offers.model';
import { RecruitingDealAlertDto } from '../../../shared/models/recruiting-deal-alert-model';

export const loadOffers = createAction('[RECRUITING DEALS COMPONENT] Load Deals for grid');

export const loadOffersSuccess = createAction(
    '[DEALS SERVICE API] Load Deals for grid Success',
    props<{ offers: any }>()
);

export const loadOffersFailure = createAction(
    '[DEALS SERVICE] Load Deals for grid Failure',
    props<{ error: unknown }>()
);

export const loadOfferLookups = createAction('[RECRUITING DEALS LOOKUPS COMPONENT] Load Offer Lookups');

export const loadOfferLookupsSuccess = createAction(
    '[DEALS LOOKUPS SERVICE API] Load Offer Lookups Success',
    props<{ lookups: GridLookups }>()
);

export const loadOfferLookupsFailure = createAction(
    '[DEALS LOOKUPS SERVICE] Load Offer Lookups Failure',
    props<{ error: unknown }>()
);

export const setOffersGridSearchQuery = createAction(
    '[DEALS GRID QUERY] Set Deals Grid search query',
    props<{ searchQuery: any }>()
);

export const getOfferInfo = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Offer Info',
    props<{ id: number }>()
);

export const getOfferInfoSuccess = createAction(
    '[DEALS SERVICE API] Load Offer Info Success',
    props<{ offerInfo: Offer }>()
);

export const getOfferInfoFailure = createAction('[DEALS SERVICE] Load Offer Info Failure', props<{ error: unknown }>());

export const getExpertiseData = createAction(
    '[RECRUITING DEALS DETAILS COMPONENT] Load Expertise Data',
    props<{ professionId: number }>()
);

export const getExpertiseDataSuccess = createAction(
    '[DEALS SERVICE API] Load Expertise Data Success',
    props<{ expertiseData: Expertise[] }>()
);

export const getExpertiseDataFailure = createAction(
    '[DEALS SERVICE] Load Expertise Data Failure',
    props<{ error: unknown }>()
);

export const exportGridData = createAction('[RECRUITING DEALS DETAILS COMPONENT] Export Grid Data');

export const exportGridDataSuccess = createAction(
    '[DEALS SERVICE API] Export Grid Data Success',
    props<{ result: ArrayBuffer }>()
);

export const exportGridDataFailure = createAction(
    '[DEALS SERVICE] Export Grid Data Failure',
    props<{ error: unknown }>()
);

export const connectToCoreHub = createAction(
    '[RECRUITING CANDIDATE OFFERS RECRUITER REVIEW COUNT ALERT] Connect to Core hub'
);
export const connectToCoreHubSuccess = createAction(
    '[RECRUITING DEALS HUB CONNECTION SERVICE] Connect to Core hub Success'
);
export const connectToCoreHubFailure = createAction(
    '[RECRUITING DEALS HUB CONNECTION SERVICE] Connect to Core hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromCoreHub = createAction(
    '[RECRUITING CANDIDATE OFFERS RECRUITER REVIEW COUNT ALERT] Disconnect from Core hub'
);
export const disconnectFromCoreHubSuccess = createAction(
    '[RECRUITING DEALS HUB CONNECTION SERVICE] Disconnect from Core hub Success'
);
export const disconnectFromCoreHubFailure = createAction(
    '[RECRUITING DEALS HUB CONNECTION SERVICE] Disconnect from Core hub Failure',
    props<{ error: unknown }>()
);
export const isHubConnectionActive = createAction(
    '[RECRUITING DEALS HUB CONNECTION SERVICE] Is hub connection active',
    props<{ isActive: boolean }>()
);

export const recruitingDealAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Deal Alert Success',
    props<{ data: RecruitingDealAlertDto }>()
);

export const recruitingDealAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Deal Alert Failure',
    props<{ error: unknown }>()
);

export const getCandidateOffersRecruiterReviewCount = createAction(
    '[RECRUITING SERVICE] Get Candidate Offers Count Under Recruiter Review Status',
    props<{ recruiterId: number }>()
);

export const getCandidateOffersRecruiterReviewCountSuccess = createAction(
    '[RECRUITING SERVICE] Get Candidate Offers Count Under Recruiter Review Status Success',
    props<{ data: RecruitingDealAlertDto }>()
);
export const noopAction = createAction(
    '[HUB CONNECTION SERVICE] Do nothing if Deal Alert is not intended for this app or login user'
);

export const getCandidateOffersRecruiterReviewCountFailure = createAction(
    '[RECRUITING SERVICE] Get Candidate Offers Count Under Recruiter Review Status Failure',
    props<{ error: string }>()
);

export const clearRecruiterDealAlertData = createAction('[RECRUITING SERVICE] Clear RecruiterDealAlert Data');

export const setOfferAsVerballyAccepted = createAction(
    '[DEALS GRID] Set offer as verbally accepted',
    props<{ offerId: number }>()
);
export const setOfferAsVerballyAcceptedSuccess = createAction(
    '[DEALS GRID] Set offer as verbally accepted success',
    props<{ offerId: number }>()
);
export const setOfferAsVerballyAcceptedFailure = createAction('[DEALS GRID] Set offer as verbally accepted failure');
